export enum CalendarBoxType {
  skipped = 'skipped'
}
